<template>
	<div class="container">
		<div class="base-div">
			<messageItem :isCanClick="false" :isCutLine="false" :item="detailModel" :isShowHeadPic="true" @toReply="toReply"/>
			<div class="message-reply-wrap">
				<div class="message-reply" v-for="item in replyList" :key="item.id">
					<messageItem :isShowReplyNum="false" :isCanClick="false" :isCutLine="false" :item="item" :isShowHeadPic="true" @toReply="toReply"/>
				</div>
			</div>
		</div>
		<div class="page-size">
			<el-pagination
			background
			layout="prev, pager, next"
			:page-size= this.pageSize
			:total=this.total
			@current-change="handleCurrentChange"
			:current-page = "pageNum"
			hide-on-single-page
			>
			</el-pagination>
		</div>
		<el-dialog title="回复留言" width="50%" :visible.sync="replyDailog">
			<div class="dialog-wrap">
				<div class="reply-title" v-if="title">
					RE：{{title}}
				</div>
				<div style="border: 1px solid #EBEBEB;">
					<Toolbar
						style="border-bottom: 1px solid #EBEBEB"
						:editor="editor"
						:defaultConfig="toolbarConfig"
						:mode="mode"
					/>
					<Editor
						style="height: 200px; overflow-y: hidden;"
						v-model="html"
						:defaultConfig="editorConfig"
						:mode="mode"
						@onCreated="onCreated"
					/>
				</div>
				<div class="create-btn" @click="createMessage">回复留言</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import messageItem from '@/components/Message/messageItem.vue'
	import qs from 'qs'
	import { post, config, ajaxParam } from '@/units/request.js'
	import '@wangeditor/editor/dist/css/style.css'
	import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
	// import { createEditor } from "@wangeditor/editor";//查看工具栏
	// const editor = createEditor({});
	// console.log('===========================')
	// console.log(editor.getAllMenuKeys(), "工具栏");
	export default {
		name: 'MessageDetail',
		data() {
			return {
				activityId: '',
				id: '',
				detailModel: {
					
				},
				pageNum: 1,
				pageSize: 15,
				total: 0,
				replyList: [],
				replyDailog: false,
				replyId: '',
				editor: null,
				toolbarConfig: {
					// toolbarKeys: [
					// 	'bold', 'underline', 'italic', 'through', 'code', 'sub', 'sup', 'clearStyle', 'color', 'bgColor'
					// ]
					excludeKeys: [
						'insertVideo'
					]
				},
				editorConfig: {
					placeholder: '请输入内容...' ,
					MENU_CONF: {
						uploadImage: {
							server: config.baseUrl + "v1/upload/editorUpload",
							fieldName: "file"
						}
					}
				},
				html: '',
				mode: 'simple', // or 'simple'
				title: ''
			}
		},
		components: {
			messageItem,
			Editor,
			Toolbar
		},
		methods: {
			onCreated(editor) {
				this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
			},
			toReply(e){
				if(!this.userId){
					this.$router.push('/login')
					return
				}
				this.replyDailog = true
				this.replyId = e.id
				this.title = e.title
				this.html = ''
			},
			//发表留言
			async createMessage(){
				if(this.html.length<=0||this.html=='<p><br></p>'){
					this.$message.error('请输入留言，不能为空！')
					return
				}
				let url = 'v1/suggest/create'
				let param = {
					activityId: this.activityId,
					content: this.html,
					addUserId: this.userId,
					replyId: this.replyId,
					title: this.title ||''
				}
				ajaxParam(param)
				const res = await post(url, qs.stringify(param))
				if(res.data.code==200) {
					this.$message.success('回复成功！')
					this.replyDailog = false
					this.getReplyList()
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//获取留言详情
			async getMessageDetail(){
				let url = 'v1/suggest/info'
				let param = {
					id: this.id
				}
				ajaxParam(param)
				const res = await post(url, qs.stringify(param))
				if(res.data.code==200) {
					this.detailModel = res.data.entity
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//根据留言id获取回复列表
			async getReplyList(){
				let url = 'v1/suggest/replyList'
				let param = {
					id: this.id,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post(url, qs.stringify(param))
				if(res.data.code==200) {
					this.replyList = res.data.list
					this.total = res.data.total
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//分页
			handleCurrentChange(e){
				this.replyList = []
				this.pageNum = e
				this.getReplyList()
			}
		},
		created(){
			this.userId = localStorage.getItem('userId')
			this.activityId = localStorage.getItem('activityId')
			if(this.$route.query.id) {
				this.id = this.$route.query.id
			}
			this.getMessageDetail()
			this.getReplyList()
		},
		beforeDestroy() {
			const editor = this.editor
			if (editor == null) return
			editor.destroy() // 组件销毁时，及时销毁编辑器
		}
	}
</script>

<style scoped lang="less">
	.container{
		background:#f7f7f7;
		overflow: hidden;
	}
	.base-div{
		margin-top: 20px;
		margin-bottom: 20px;
		padding-top: 10px;
		background: #fff
	}
	.container /deep/ .el-dialog__body  {
		padding-top: 0
	}
	.reply-title{
		padding-bottom: 20px;
		font-weight: bold;
	}
	.page-size{
		margin-bottom: 30px;
	}
</style>
